module.exports = __webpack_public_path__ + "img/tlo_wypadek.7de0527d.jpg";